<mat-button-toggle-group
    [value]="selectedOption"
    (change)="onOptionSelect.emit($event.value)"
    [hideSingleSelectionIndicator]="true"
    [attr.aria-label]="ariaLabel | translate">
    @for (option of options; track option) {
        <mat-button-toggle [value]="option.value" [class]="option.class">
            {{ option.label | translate }}
        </mat-button-toggle>
    }
</mat-button-toggle-group>
